import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { Stop, Trip, IActivo, IQueryTripero } from 'modelos/src';
import { Subscription } from 'rxjs';
import { DateRange } from '../../../../../../../auxiliares/date-range-selector/date-range-selector.component';
import { Lista2Service } from '../../../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-controles',
  templateUrl: './controles.component.html',
  styleUrl: './controles.component.scss',
  standalone: false,
})
export class ControlesComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);

  @Input() vehiculo!: IActivo;

  public loadingViajes = false;
  public loadingParadas = false;

  public toggle = true; // True = Viajes, False = Paradas
  public rangoViajes?: DateRange;
  public rangoParadas?: DateRange;
  //
  @Input() viajeSelected?: Trip;
  @Output() viajeSelectedChange = new EventEmitter<Trip>();
  public viajes: Trip[] = [];
  public viajes$?: Subscription;

  @Input() paradaSelected?: Stop;
  @Output() paradaSelectedChange = new EventEmitter<Stop>();
  public paradas: Stop[] = [];
  public paradas$?: Subscription;

  private async listarViajes() {
    this.loadingViajes = true;
    if (!this.rangoViajes) {
      return;
    }
    const query: IQueryTripero = {
      idVehiculo: this.vehiculo._id!,
      from: this.rangoViajes.start,
      to: this.rangoViajes.end,
    };
    this.viajes$?.unsubscribe();
    this.viajes$ = this.lista2.viajes(query, 30).subscribe((data) => {
      // sort by descending startTime
      if (data && !this.viajeSelected && !this.paradaSelected) {
        this.viajes = data.sort((a, b) => {
          return a.startTime! > b.startTime! ? -1 : 1;
        });
      }
      this.loadingViajes = false;
    });
  }

  public async onViajesRangeChange(rango: DateRange) {
    this.rangoViajes = rango;
    await this.listarViajes();
  }

  public onViajesSelected(viaje: Trip, expanded: boolean) {
    if (expanded) {
      // Seleccionar nuevo viaje
      this.viajeSelected = viaje;
      this.viajeSelectedChange.emit(viaje);
    } else {
      // Solo limpiar si el viaje que se colapsa es el actualmente seleccionado
      // Esto evita que el colapso del viaje anterior sobrescriba la nueva selección
      if (this.viajeSelected === viaje) {
        this.viajeSelected = undefined;
        this.viajeSelectedChange.emit(undefined);
      }
    }
  }

  private async listarParadas() {
    this.loadingParadas = true;
    if (!this.rangoParadas) {
      return;
    }
    const query: IQueryTripero = {
      idVehiculo: this.vehiculo._id!,
      from: this.rangoParadas.start,
      to: this.rangoParadas.end,
    };
    this.paradas$?.unsubscribe();
    this.paradas$ = this.lista2.paradas(query, 30).subscribe((data) => {
      // sort by descending startTime
      if (data && !this.viajeSelected && !this.paradaSelected) {
        this.paradas = data.sort((a, b) => {
          return a.startTime! > b.startTime! ? -1 : 1;
        });
      }
      this.loadingParadas = false;
    });
  }

  public async onParadasRangeChange(rango: DateRange) {
    this.rangoParadas = rango;
    await this.listarParadas();
  }

  public onParadasSelected(parada: Stop, expanded: boolean) {
    if (expanded) {
      // Seleccionar nueva parada
      this.paradaSelected = parada;
      this.paradaSelectedChange.emit(parada);
    } else {
      // Solo limpiar si la parada que se colapsa es la actualmente seleccionada
      // Esto evita que el colapso de la parada anterior sobrescriba la nueva selección
      if (this.paradaSelected === parada) {
        this.paradaSelected = undefined;
        this.paradaSelectedChange.emit(undefined);
      }
    }
  }

  async ngOnInit(): Promise<void> {
    const to = new Date();
    const from = new Date(to);
    // from.setHours(from.getHours() - 48);
    from.setDate(from.getDate() - 2);

    const defaultRange: DateRange = {
      start: from.toISOString(),
      end: to.toISOString(),
    };
    this.rangoViajes = defaultRange;
    this.rangoParadas = defaultRange;

    await Promise.all([this.listarViajes(), this.listarParadas()]);
  }

  ngOnDestroy() {
    this.viajes$?.unsubscribe();
    this.paradas$?.unsubscribe();
  }
}
